/*****************************************************************************************************************************************************
 * Revision History
 * 2025-04-18 TBH - Set selectedCourse[ item ] in addSelectedCourse() "false" if event != "on".
 *     If not done a course selected to be dropped, then unselected, would still be dropped.
 *****************************************************************************************************************************************************/
import { MyAccountUrl } from "../directives/utilities/urls";

export default function coursesAvailableToDrop() {
  return {
    dropScheduleList: [],
    pendingDropScheduleList: [],
    totalRefund:0,
    selectedCourse:[],
    isCoursesAvailableToDrop: true,
    isCoursesAvailableToDropMessage: '',
    isPendingCoursesAvailableToDrop: true,
    isPendingCoursesAvailableToDropMessage: '',
    successCount: 0,
    failCount:0,
    isSubmitMessage: false,
    submitMessage: '',
    processedCount: 0,
    selectedCourseCount:0,
    showLoader: false,

    formatDate(dateValue) {
      if( dateValue != undefined && dateValue != "" && dateValue != null && dateValue != "N/A" && dateValue != 0 ) {
        const date = new Date(dateValue);
        const month = date.getMonth() + 1; // Month is zero-based, so add 1
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      } else {
        return dateValue;
      }
    },

    addSelectedCourse( event, item ) {
// console.log( 'addSelectedCourse( ' + event + ', ' + item + ' )' );
      if( this.selectedCourse[ item ] == "true" )
        this.selectedCourse[ item ] = "false";
      else
        this.selectedCourse[ item ] = "true";
// console.log( 'this.selectedCourse[ ' + item + ' ] = ' + this.selectedCourse[ item ]);
    },

    bindDropSchedule() {
// console.log( 'bindDropSchedule()' );
      this.showLoader = true;
      this.selectedCourse = [];
      fetch( '/api/StudentAPI/GetDropSchedule', { 
        "method": "GET" 
      }).then( response => {
          if( response.ok ) {
            return response.json()
          }
      }).then(response => {
        if (response != undefined && response.isSuccess) {
          this.dropScheduleList = response.scheduleList;
// console.log( 'dropScheduleList: ' + JSON.stringify( this.dropScheduleList ));
          if( this.dropScheduleList.length <= 0 ) {
            this.isCoursesAvailableToDrop = false;
            this.showLoader = false;
            this.isCoursesAvailableToDropMessage =
                "You are currently not enrolled in any courses or the courses you are enrolled in have been completed.<br/><br/>" +
                "To view your schedule <a href='/my-account/my-schedule'>click here</a>.";
          } else {
            this.isCoursesAvailableToDrop = true;
            this.isCoursesAvailableToDropMessage = "";
            for( let j = 0; j < this.dropScheduleList.length; j++ ) {
              this.selectedCourse[ j ] = "false";
            }
          this.showLoader = false;
          }
        } else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later."
        }
      });
    },
        
    checkDropCoursesAllowed() {
// console.log( 'checkDropCoursesAllowed()' );
      fetch('/api/StudentAPI/CheckDropCoursesAllowed', { 
        "method": "GET" 
      }).then(response => {
        if (response.ok) {
          return response.json()
        }
      }).then(response => {
        if( response != undefined && response.isSuccess ) {
          if( response.allowDropCourse ) {
            this.bindDropSchedule();
          } else {
            window.location.href = MyAccountUrl;
          }
        } else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later."
        }
      });
    },

    initiateDropCourses() {
// console.log( 'initiateDropCourses()' );
      this.successCount = 0;
      this.failCount = 0;
      this.processedCount = 0;
      this.selectedCourseCount = 0;
// console.log( 'dropScheduleList.length: ' + this.dropScheduleList.length );
      if( this.dropScheduleList.length > 0 ) {
        for( let i = 0; i < this.dropScheduleList.length; i++ ) {
          if( this.selectedCourse[ i ] == "true" ) {
            this.selectedCourseCount++;
            fetch('/api/StudentAPI/InitiateDropCourses', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                AcademicYear: this.dropScheduleList[i].academicYear,
                AcademicTerm: this.dropScheduleList[i].academicTerm,
                AcademicSession: this.dropScheduleList[i].academicSession,
                SerialId: this.dropScheduleList[i].serialId,
                EventSubType: this.dropScheduleList[i].eventSubType,
                EventId: this.dropScheduleList[i].eventId,
                Section: this.dropScheduleList[i].section,
              })
            }).then(response => {
              return response.json();
            }).then(response => {
              this.processedCount += 1;
              if( response.isSuccess ) {
                this.successCount += 1;
              } else {
                this.failCount += 1;
              }
            });
          }
        }

        if( this.selectedCourseCount == 0 ) {
          this.isSubmitMessage = false;
          this.submitMessage = "Please select which course(s) you would like to drop, then click ‘Drop Selected Courses’";
          return;
        }

        if( this.processedCount == this.successCount ) {
          this.isSubmitMessage = true;
          window.location.href = document.getElementById( 'pendingDropPageUrl' ).value;
        } else {
          this.isSubmitMessage = false;
          this.submitMessage = "Something went wrong."
        }
      }
    },

    init() {
      this.checkDropCoursesAllowed();
    }
  }
}